import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
const CryptoCarouselItemSkeleton = () => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute top-0 left-1/2 z-10 h-12 w-12 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gray-200" />;
    t1 = <div className="my-2 h-5 w-1/2 rounded bg-gray-200" />;
    t2 = <div className="mx-auto mt-2 mb-6 h-4 w-1/4 rounded bg-gray-200" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex w-full justify-between border-t border-gray-200 py-5"><div className="flex w-full flex-row items-center"><div className="mr-2 h-4 w-4 rounded bg-gray-200" /> Buy</div><span className="text-h8 h-5 w-16 rounded bg-gray-200 font-bold" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="min-w-mobileSlider shadow-elevation-4 lg:min-w-slider relative mt-16 mr-5 mb-10 flex animate-pulse flex-col items-center overflow-visible rounded-[0.625rem] border border-gray-200 px-8 pt-9 pb-8 lg:mt-28 lg:mb-12 lg:px-7" data-sentry-component="CryptoCarouselItemSkeleton" data-sentry-source-file="index.tsx">{t0}{t1}{t2}{t3}<div className="flex w-full flex-row items-center justify-between border-t border-gray-200 pt-5"><div className="flex w-full flex-row items-center"><div className="mr-2 h-4 w-4 rounded bg-gray-200" /> Sell</div><span className="text-h8 h-5 w-16 rounded bg-gray-200 font-bold" /></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default CryptoCarouselItemSkeleton;